<template lang="html">
  <div
    class="mobile-menu"
    v-if="$route.name !== 'home'"
    :class="{ active: mobileMenu }"
    @click="hideMenu"
  >
    <router-link
      class="menu-link"
      v-for="page in pages"
      :key="page.uid"
      :to="{ name: page.uid }"
      :class="{ active: mobileMenu }"
    >
      {{ page.title }}
    </router-link>
  </div>
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      pages: [],
      mobileMenu: false,
    };
  },
  mounted() {
    this.$root.$on("toggleMenu", this.toggleMenu);
  },
  watch: {
    $route(to, from) {
      if (to.params.lang !== from.params.lang) {
        API.pages(this.$i18n.locale).then((page) => {
          this.pages = page.data.result.data;
        });
      }
    },
  },
  created() {
    API.pages(this.$i18n.locale).then((page) => {
      this.pages = page.data.result.data;
    });
  },
  methods: {
    toggleMenu(value) {
      this.mobileMenu = value;
    },
    hideMenu() {
      this.$root.$emit("toggleMenu", false);
      this.mobileMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-menu {
  position: fixed;
  z-index: 20;
  top: 100%;
  left: 0;
  width: 100%;
  background: var(--bg);
  padding: 0 var(--lh);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  transition: transform 0.5s;
  &.active {
    transform: translate(0, -100%);
  }
  a {
    flex: 0 0 100%;
    padding: calc(0.5 * var(--lh)) 0;
  }
}
</style>
